import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { allowedNotificationTypes, phoneNotificationTypes, tagNotificationsType } from '@frontend/settings-routing';
import { SoundId, SoundSettings } from '@frontend/types';
import { ArchivedNote, PreferenceDict } from './types';
/**
 * This file contains the default values for user preferences in the application.
 */

export const getSoundSettings = () => {
  const settings: Record<any, SoundId | ''> = {};
  [...allowedNotificationTypes, ...phoneNotificationTypes, ...tagNotificationsType].forEach((notification) => {
    settings[notification.type] = '';
  });
  return settings as SoundSettings;
};

const defaultFilterValues = [
  NotificationType.SMS,
  NotificationType.SCHEDULE_REQUEST,
  NotificationType.SCHEDULE_WAITLIST_UPDATE,
  NotificationType.PAYMENTS,
  NotificationType.CALL_RECORD_TAG,
  NotificationType.FAX_TAG,
  NotificationType.SMS_TAG_V2,
  NotificationType.ROBOCALL_TAG,
  NotificationType.VOICEMAIL_TAG,
  NotificationType.FAX,
  NotificationType.FORMS,
  NotificationType.REVIEWS,
  NotificationType.VOICEMAIL_MESSAGE,
  'TAGS' as NotificationType,
  NotificationType.CALL_INTELLIGENCE_UNHAPPY_CALL,
];

const defaultColorValues = {
  [NotificationType.SMS]: 'tangerine',
  [NotificationType.SCHEDULE_REQUEST]: 'rose',
  [NotificationType.SCHEDULE_WAITLIST_UPDATE]: 'rose',
  [NotificationType.PAYMENTS]: 'success',
  ['Tags' as NotificationType]: 'critical',
  [NotificationType.VOICEMAIL_MESSAGE]: 'eggplant',
  [NotificationType.CHAT_MESSAGE]: 'indigo',
  [NotificationType.REVIEWS]: 'neutral',
  [NotificationType.FORMS]: 'primary',
  [NotificationType.FAX]: 'warning',
  [NotificationType.TASK]: 'indigo',
  [NotificationType.CALL_INTELLIGENCE_UNHAPPY_CALL]: 'gradient',
};

const defaultScheduleOnboardingFlowInfo: SchedulerV3.Types.ScheduleOnboardingFlowInfo = {
  status: 'not_started',
};

const currentStickyNoteDefault = '';
const archivedNotesDefault: ArchivedNote[] = [];

export const DEFAULT_PREFERENCES = {
  ForYouNotificationFilters: defaultFilterValues,
  ScheduleOnboardingFlowInfo: defaultScheduleOnboardingFlowInfo,
  StickyNoteYellowCurrentNote: currentStickyNoteDefault,
  StickyNoteYellowArchivedNotes: archivedNotesDefault,
  StickyNoteBlueCurrentNote: currentStickyNoteDefault,
  StickyNoteBlueArchivedNotes: archivedNotesDefault,
  StickyNoteGreenCurrentNote: currentStickyNoteDefault,
  StickyNoteGreenArchivedNotes: archivedNotesDefault,
  StickyNotePurpleCurrentNote: currentStickyNoteDefault,
  StickyNotePurpleArchivedNotes: archivedNotesDefault,
  StickyNotePinkCurrentNote: currentStickyNoteDefault,
  StickyNotePinkArchivedNotes: archivedNotesDefault,
  StickyNoteOrangeCurrentNote: currentStickyNoteDefault,
  StickyNoteOrangeArchivedNotes: archivedNotesDefault,
  GlobalSearchRecentSearches: [],
  NotificationFilters: [],
  NotificationSettings: {
    hasChangedDuration: false,
    manageAll: true,
    notificationSettings: {
      durationMs: 4000,
      placement: 'top-right',
    },
    notificationSounds: getSoundSettings(),
  },
  ForYouNotificationColors: defaultColorValues,
  PreferredOutboundLocationPhone: {},
  TeamChatHideConversationModalHide: false,
  ScheduleCalendarViewColumnOrder: {
    provider: {},
    operatory: {},
  },
  TeamChatHideLinksSecurityModal: false,
  ScheduleCalendarSettings: {
    zoomLevel: 1,
    waitlistNewNameModalDismissedTimes: 0,
  },
  TeamPresenceDemoDismissed: false,
  // Add more keys as we grow...
} as const satisfies Partial<PreferenceDict>;

export type DefaultPreferencesType = keyof typeof DEFAULT_PREFERENCES;
